import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'


// Portal views
import LoginView from '@/views/LoginView.vue'
import PortalView from '@/views/PortalView.vue'
import DashboardView from '@/views/DashboardView.vue'
import AdminView from '@/views/AdminView.vue'
import RequestsView from '@/views/RequestsView.vue'
import InventoryView from '@/views/InventoryView.vue'
import RequestFormView from '@/views/RequestFormView.vue'

const routes: Array<RouteRecordRaw> = [
  // Portal routes
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/signup',
    redirect: '/login?signup=true'
  },
  {
    path: '/',
    component: PortalView,
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        name: 'PortalDashboard',
        component: DashboardView
      },
      {
        path: 'admin',
        name: 'PortalAdmin',
        component: AdminView
      },
      {
        path: 'requests',
        name: 'PortalRequests',
        component: RequestsView
      },
      {
        path: 'inventory',
        name: 'PortalInventory',
        component: InventoryView
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


//Uncomment this to enable auth
// router.beforeEach((to, from, next) => {
//   if (to.name !== 'Login' && !isLoggedIn()) 
//   {

//     next({ name: 'Login' })
  
//   } else {
//     next()
//   }
// })

export default router
